import React from "react";
import { Button, Container, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

import { appRoutes } from "routes";

import useStyles from "./useStyles";

const Hero = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.content}>
          <Typography variant="h3" className={classes.label}>
            Ecards for
          </Typography>
          <Typography variant="h3" className={classes.tagline}>
            A Birthday
            <br />
            Celebration
          </Typography>
          <Button component={Link} className={classes.button} to={appRoutes.categoryPath("birthday-ecards")}>
            BROWSE BIRTHDAYS
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default Hero;
